import * as Msal from 'msal';

const msalConfig = {
  auth: {
      clientId: "247465bf-4eac-4258-b2f3-47e901a11a9c",
      authority: "https://login.microsoftonline.com/3bef4b8f-156b-4ec1-8ce1-863209a39c22",
      redirectUri: "https://localhost:8080/sign-in/",
  },
  cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  graphScopes: ['user.read']
};

export default class AuthService {
  constructor() {
    this.app = new Msal.UserAgentApplication(msalConfig);
  }

  login() {
    return this.app.loginPopup(msalConfig.graphScopes).then(
      idToken => {
        const user = this.app.getUser();
        console.log("token: " + idToken);
        if (user) {
          return user;
        } else {
          return null;
        }
      },
      () => {
        return null;
      }
    );
  }

  logout() {
    this.app.logout();
  }

  getToken() {
    return this.app.acquireTokenSilent(msalConfig.graphScopes).then(
      accessToken => {
        return accessToken;
      },
      error => {
        console.log("token: " + error);
        return this.app
          .acquireTokenPopup(msalConfig.graphScopes)
          .then(
            accessToken => {
              return accessToken;
            },
            err => {
              console.error(err);
            }
          );
      }
    )
  }
}